module.exports = __webpack_public_path__ + "img/93b4daa.jpg";